<template>
  <input
    type="text"
    inputmode="numeric"
    pattern="\d*"
    @keydown="validateKey"
    :value="modelValue"
    @input="(e) => newValue(e.target?.value)"
    class="input input-bordered"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
  min?: number;
  max?: number;
}>();

const emit = defineEmits<{
  (_e: "update:modelValue", _value: number): void;
}>();

const validateKey = (e: KeyboardEvent) => {
  const re = /\d/;
  // Prevent input if it's a regular letter which is not a number,
  // but also prevent input if we reached max number value.
  // FIXME: won't work for negative values
  if (e.key.length == 1 && (!re.test(e.key) || props.modelValue == props.max)) {
    e.preventDefault();
  }
};

const newValue = (value: string) => {
  const num = value == "" ? 0 : Number(value);
  if (isNaN(num)) {
    return;
  }
  const min = props.min ?? Number.NEGATIVE_INFINITY;
  const max = props.max ?? Number.POSITIVE_INFINITY;
  const int = Math.max(min, Math.min(max, Math.round(num)));
  emit("update:modelValue", int);
};
</script>
